<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Dry-Off Process
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <report-comment field_name="heading_dryoff_process" :model="model.COMMENTS" :heading="true"> </report-comment>
      <subsection
        :title="`Dry-Off Process - ${farm.farm_label}`"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-dryoff`"
        v-for="farm in model.FARMS"
        :key="`farm_${farm.id}-dryoff`"
      >
        <dl class="dl-horizontal">
          <dt>Do you want to teatseal only?</dt>
          <dd>{{ model[`farm_${farm.id}-wants_teat_seal_only`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Vetsouth application?</dt>
          <dd>{{ model[`farm_${farm.id}-wants_vs_application`] || '-' }}</dd>
        </dl>
      </subsection>

      <subsection
        :title="`Dry off areas discussion - ${farm.farm_label}`"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-dryoff_areas_discussion`"
        v-for="farm in model.FARMS"
        :key="`farm_${farm.id}-dryoff_areas_discussion`"
      >
        <dl class="dl-horizontal">
          <dt>Pre dry off areas comments:</dt>
          <dd>{{ model[`farm_${farm.id}-pre_dry_off_area_comments`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Post dry off areas comments:</dt>
          <dd>{{ model[`farm_${farm.id}-post_dry_off_area_comments`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Wintering and Crop</dt>
          <dd>{{ model[`farm_${farm.id}-wintering_and_crop_comments`] || '-' }}</dd>
        </dl>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'DryOffProcess',
  mixins: [mixin],
}
</script>
